import {useQuery} from "@tanstack/react-query";
import {readShippingSelectBox} from "../../../../../api/order/OrdersApi";

export const useReadShippingSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readShippingSelectBox"],
        queryFn: async () => await readShippingSelectBox(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
